import React from 'react';

const Marquee = ({ settings }) => {
    const { text, backgroundColor = '#000000', textColor = '#ffffff', speed = 20 } = settings;

    if (!text) return null;

    return (
        <div 
            className="w-full overflow-hidden py-2 border-b border-gray-200"
            style={{ backgroundColor, color: textColor }}
        >
            <style>
                {`
                    @keyframes marquee {
                        0% { transform: translateX(0); }
                        100% { transform: translateX(-50%); }
                    }
                    .animate-marquee {
                        display: flex;
                        width: max-content;
                        animation: marquee ${speed}s linear infinite;
                    }
                    .animate-marquee:hover {
                        animation-play-state: paused;
                    }
                `}
            </style>
            <div className="animate-marquee text-xs font-semibold tracking-widest uppercase flex items-center whitespace-nowrap">
                {/* Repeat content enough times to ensure smooth scrolling */}
                {[...Array(10)].map((_, i) => (
                    <div key={i} className="flex items-center gap-12 px-6 shrink-0">
                        <span>{text}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Marquee;
